// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606021021/js/" + chunkId + "." + {"44":"c262fded","225":"71d5a5af","481":"d144f41b","486":"9bf1e1b0","770":"591c7c05"}[chunkId] + ".0.22925499550446138.chunk.js";
};